import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12341372"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "number_draw"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "new"
};
const _hoisted_4 = {
  style: {
    "color": "red"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "history"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/record"
}, "历史记录")], -1));
const _hoisted_6 = {
  class: "nd_plural"
};
const _hoisted_7 = {
  class: "sxname"
};
const _hoisted_8 = {
  class: "next"
};
const _hoisted_9 = {
  class: "nextopen"
};
const _hoisted_10 = {
  style: {
    "color": "#007539"
  }
};
const _hoisted_11 = {
  class: "daojis"
};
const _hoisted_12 = {
  style: {
    "color": "#007539"
  }
};
import axios from "axios"; 
import { ref, reactive, onBeforeMount } from 'vue';
//原生的axios 

export default {
  __name: 'priz_result',
  setup(__props) {
    let numarray = ref({
      Day: "12",
      Moon: "05",
      Nq: "132",
      Qi: "131",
      Time: "21点33分",
      Week: "周五",
      Year: "2023",
      data: [{
        "nim": "水",
        "number": "28",
        "style": "green",
        "sx": "鼠"
      }, {
        "nim": "木",
        "number": "05",
        "style": "green",
        "sx": "猪"
      }, {
        "nim": "火",
        "number": "38",
        "style": "green",
        "sx": "虎"
      }, {
        "nim": "金",
        "number": "23",
        "style": "red",
        "sx": "蛇"
      }, {
        "nim": "火",
        "number": "29",
        "style": "red",
        "sx": "猪"
      }, {
        "nim": "火",
        "number": "08",
        "style": "red",
        "sx": "猴"
      }, {
        "nim": "木",
        "number": "43",
        "style": "green",
        "sx": "鸡"
      }]
    });
    let hours = ref('00');
    let minutes = ref('00');
    let seconds = ref('00');
    const tow = n => {
      return n >= 0 && n < 10 ? '0' + n : '' + n;
    };
    let numCode = reactive([]);
    let old_nmuCode = reactive([]);
    let priz = () => {
      // numCode.length = 0;
      // old_nmuCode.length = 0
      let a = [];
      let b = [];
      let url = 'https://6ckj.tukukj.com:1888/api?name=48am';
      axios.get(url).then(res => {
        let data = res.data.data;
        data.Time = data.Time.replace('点', ':').replace('分', '');
        for (var i = 1; i <= 7; i++) {
          a.push(data.Data[i]);
          b.push(data.Data[i]);
        }
        numCode = a;
        old_nmuCode = b;
        numarray.value = data;
      });
    };
    onBeforeMount(() => {
      let url = 'https://6ckj.tukukj.com:1888/api?name=48am';
      axios.get(url).then(res => {
        let data = res.data.data;
        data.Time = data.Time.replace('点', ':').replace('分', '');
        for (var i = 1; i <= 7; i++) {
          numCode.push(data.Data[i]);
          old_nmuCode.push(data.Data[i]);
        }
        numarray.value = data;
        randomNumber(numCode, old_nmuCode);
        setInterval(() => {
          getDate(data);
        }, 1000);
      });
    });
    let randomNumber = (a, b) => {
      let cset;
      a.forEach((item, i) => {
        if (!(parseInt(item.number) < 50 && parseInt(item.number) > 0)) {
          setInterval(() => {
            b[i].number = Math.floor(Math.random() * 49 + 1);
            b[i].style = colorarray[cons(b[i].number, numarrays)];
          }, 500);
        } else {
          b[i].number = item.number;
        }
      });
    };
    let numarrays = [[1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46], [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48], [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]];
    let cons = (d, array) => {
      let b = 0;
      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < array[i].length; j++) {
          if (array[i][j] == d) {
            b = i;
          }
        }
      }
      return b;
    };
    let colorarray = ['blue', 'green', 'red'];
    let sxCode = [[1, 13, 25, 37, 49], [2, 14, 26, 38], [3, 15, 27, 39], [4, 16, 28, 40], [5, 17, 29, 41], [6, 18, 30, 42], [7, 19, 31, 43], [8, 20, 32, 44], [9, 21, 33, 45], [10, 22, 34, 46], [11, 23, 35, 47], [12, 24, 36, 48]];
    const getDate = data => {
      // var oDate = new Date();//获取日期对象
      // var oldTime = oDate.getTime();//现在距离1970年的毫秒数
      // var newDate = new Date(`${data.Year}/${data.Moon}/${data.Day} ${data.Time}:00 GMT+08:00`);
      // var newTime = newDate.getTime();//2019年距离1970年的毫秒数
      let c = data.Time.split(':');
      let t = c[0] * 3600 + c[1] * 60;
      let nh = new Date().getUTCHours() + 8;
      let nm = new Date().getMinutes();
      let ns = new Date().getSeconds();
      let nt = nh * 3600 + nm * 60 + ns;
      let dt = nt < t ? t - nt : 24 * 3600 + t - nt;
      let dh = Math.floor(dt / 3600);
      if (dh < 10) {
        dh = '0' + dh;
      }
      let dm = Math.floor(dt % 3600 / 60);
      if (dm < 10) {
        dm = '0' + dm;
      }
      let ds = dt % 3600 % 60;
      if (ds < 10) {
        ds = '0' + ds;
      }
      if (dh == 23 && dm > 56) {
        hours.value = '00';
        minutes.value = '00';
        seconds.value = '00';
        priz();
      } else {
        hours.value = dh;
        minutes.value = dm;
        seconds.value = ds;
      }

      // var second = Math.floor((newTime - oldTime) / 1000);//未来时间距离现在的秒数
      // var hour = Math.floor(second / 3600);//整数部分代表小时；
      // second %= 3600; //余数代表 剩下的秒数；
      // var minute = Math.floor(second / 60);
      // second %= 60;
      // hours.value = tow(hour);
      // minutes.value = tow(minute);
      // seconds.value = tow(second);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(" 第 "), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(numarray).Qi) + "期", 1), _createTextVNode(" 最新开奖结果 ")]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(old_nmuCode), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("div", {
          class: _normalizeClass('num ' + item.style)
        }, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.sx) + "/" + _toDisplayString(item.nim), 1), _createElementVNode("span", null, _toDisplayString(item.number), 1)], 2)]);
      }), 128))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createTextVNode(" 下期开奖日期: "), _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(numarray).Year + '-' + _unref(numarray).Moon + '-' + _unref(numarray).Day + ' ' + _unref(numarray).Time), 1)]), _createElementVNode("div", _hoisted_11, [_createTextVNode(" 直播倒计时: "), _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(hours)) + ":" + _toDisplayString(_unref(minutes)) + ":" + _toDisplayString(_unref(seconds)), 1)])])]);
    };
  }
};